import AppExtensionsSDK, {
  Command,
  Event,
  Modal,
  View,
} from '@pipedrive/app-extensions-sdk';
import { logEnabled, errorLogEnabled } from './Utils.js';

let SDK;
// Initialize SDK and set height. If SDK is already initialized, just return it.
export const getCustomUISDK = async () => {
  try {
    if (SDK) return SDK;
    logEnabled && console.log('Initializing SDK');
    SDK = await new AppExtensionsSDK().initialize({ size: { width: 450, height: 500} });
    document.documentElement.setAttribute('data-theme', SDK.userSettings.theme);
    return SDK;
  } catch (e) {
    errorLogEnabled && console.error('Error during SDK initialization', e);
  }
};

export const hideFloatingWindow = async (sdk) => {
  logEnabled && console.log('Hiding floating window');
  await sdk.execute(Command.HIDE_FLOATING_WINDOW, {});
};

export const showFloatingWindow = async (sdk) => {
  logEnabled && console.log('Showing floating window');
  await sdk.execute(Command.SHOW_FLOATING_WINDOW, {});
};

export const openActivityModal = async (sdk) => {
  logEnabled && console.log('Opening activity modal');
  await sdk.execute(Command.OPEN_MODAL, {
    type: Modal.ACTIVITY,
  });
};

export const openPersonModal = async (sdk, prefill) => {
  logEnabled && console.log('Opening person modal with prefill', prefill);
  await sdk.execute(Command.OPEN_MODAL, {
    type: Modal.PERSON,
    prefill: prefill || {},
  });
};

export const redirectToContact = async (sdk, id) => {
  logEnabled && console.log(`Redirecting to ${id}`);
  await sdk.execute(Command.REDIRECT_TO, { view: View.CONTACTS, id });
};

export const setNotification = async (sdk, number) => {
  logEnabled && console.log(`Updating notification count to ${number}`);
  await sdk.execute(Command.SET_NOTIFICATION, {
    number,
  });
};

export const subsribeToVisibilityEvents = async (sdk, handleVisibilityEvent) => {
  sdk.listen(Event.VISIBILITY, ({ error, data }) => {
    error && errorLogEnabled && console.error('Error in visibility event', error);
    handleVisibilityEvent(data);
  })
}